/**
 * Utilitaires pour la manipulation des couleurs
 */

/**
 * Assombrit une couleur de 15%
 * @param color Couleur en format hex (#RRGGBB) ou rgb/rgba
 * @returns Couleur assombrie
 */
export const darkenColor = (color: string): string => {
  // Si la couleur est en hexadécimal
  if (color.startsWith('#')) {
    const hex = color.slice(1);
    const num = parseInt(hex, 16);
    const r = Math.floor((num >> 16) * 0.85);
    const g = Math.floor(((num >> 8) & 0x00FF) * 0.85);
    const b = Math.floor((num & 0x0000FF) * 0.85);
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
  }
  
  // Si la couleur est en rgb/rgba
  if (color.startsWith('rgb')) {
    const matches = color.match(/\d+/g);
    if (matches && matches.length >= 3) {
      const r = Math.floor(parseInt(matches[0]) * 0.85);
      const g = Math.floor(parseInt(matches[1]) * 0.85);
      const b = Math.floor(parseInt(matches[2]) * 0.85);
      const a = matches[3] ? parseFloat(matches[3]) : 1;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    }
  }
  
  // Retourner la couleur originale si non reconnue
  return color;
};

/**
 * Crée un dégradé avec effet de fondu accentué
 * @param color Couleur de base
 * @param isVisible Si l'élément est visible
 * @returns String du dégradé CSS
 */
export const createFadedGradient = (color: string, isVisible: boolean): string => {
  if (isVisible) {
    const darkened = darkenColor(color);
    return `linear-gradient(to right, ${darkened}99 0%, ${darkened}cc 15%, ${darkened} 85%, ${darkened}99 100%)`;
  }
  return 'linear-gradient(to right, rgba(90, 90, 90, 0.25) 0%, rgba(90, 90, 90, 0.2) 15%, rgba(90, 90, 90, 0.2) 85%, rgba(90, 90, 90, 0.25) 100%)';
};

/**
 * Crée des ombres accentuées pour la profondeur
 * @param isVisible Si l'élément est visible
 * @returns String des box-shadows CSS
 */
export const createDepthShadow = (isVisible: boolean): string => {
  if (isVisible) {
    return 'inset 0 2px 4px rgba(0, 0, 0, 0.2), inset 0 -2px 4px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.1)';
  }
  return 'inset 0 1px 2px rgba(0, 0, 0, 0.1), inset 0 -1px 2px rgba(0, 0, 0, 0.15), 0 1px 1px rgba(0, 0, 0, 0.05)';
};
